export const messages = {
  en: {
    resourceOutManage: {
      title: 'Resource Out Management',
      orderNumber: 'Order Number',
      itemName: 'Item Name',
      itemCode: 'Item Code',
      itemStock: 'Item Stock',
      applyQuantity: 'Apply Quantity',
      issueQuantity: 'Issue Quantity',
      remarks: 'Remarks',
      submit: 'Submit',
      quantityRequired: 'Quantity is required',
      insufficientStock: 'Insufficient stock',
      processSuccess: 'Process success',
      processFailed: 'Process failed'
    }
  },
  zh: {
    resourceOutManage: {
      title: '资源出库管理',
      orderNumber: '单号',
      itemName: '物品名称',
      itemCode: '物品编码',
      itemStock: '物品库存',
      applyQuantity: '申请数量',
      issueQuantity: '发放数量',
      remarks: '备注',
      submit: '提交',
      quantityRequired: '采购数量未填写',
      insufficientStock: '库存不足',
      processSuccess: '处理成功',
      processFailed: '处理失败'
    }
  }
}